require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./derechos-de-tv-la-ley-bosman-y-el-poder-economico-asi-fue-que-la-champions-supero-a-la-libertadores.json") })
        }
      }, "path---derechos-de-tv-la-ley-bosman-y-el-poder-economico-asi-fue-que-la-champions-supero-a-la-libertadores");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---derechos-de-tv-la-ley-bosman-y-el-poder-economico-asi-fue-que-la-champions-supero-a-la-libertadores!./.cache/json/derechos-de-tv-la-ley-bosman-y-el-poder-economico-asi-fue-que-la-champions-supero-a-la-libertadores.json
// module id = 445
// module chunks = 231608221292675